import React, { useEffect, useState } from "react";

import {
  Container,
  Typography
} from "@mui/material";

import {
  useParams,
  useNavigate
} from "react-router-dom";

import { toast } from "react-toastify";

import config from "../../config";

import "bootstrap/dist/css/bootstrap.css";

function ViewRepoChecklist() {

  const { repoId } = useParams();
  const decodedRepoId = repoId ? atob(repoId) : "";

  const navigate = useNavigate();

  const [data, setData] = useState(null);

  const fetchData = async () => {

    try {

      const res = await fetch(
        `${config.API_BASE_URL}getRepoChecklistDetails/${decodedRepoId}`
      );

      const result = await res.json();

      console.log(result);

      if (result.status) {

        setData(result.data);

      } else {

        toast.error(result.message);

      }

    } catch {

      toast.error("Failed to load checklist");

    }

  };

  useEffect(() => {

    fetchData();

  }, []);

  if (!data) {

    return (
      <Container className="mt-5">
        <Typography>Loading...</Typography>
      </Container>
    );

  }

  const renderValue = (value) => {

    if (
      value === null ||
      value === undefined ||
      value === ""
    ) {

      return "-";

    }

    if (Array.isArray(value)) {

      return value.join(", ");

    }

    return value;

  };

  return (

    <Container maxWidth="xl" className="mt-4 mb-5">

      <div className="d-flex justify-content-between align-items-center mb-4">

        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            color: "#1f2937"
          }}
        >
          View Repo Checklist
        </Typography>

        <button
          className="btn btn-warning fw-bold px-4"
          onClick={() =>
            navigate(
              `/dashboard/repo-conditions-checklist/${btoa(decodedRepoId)}`
            )
          }
        >
          EDIT CHECKLIST
        </button>

      </div>

      <div
        className="card border-0 shadow-sm"
        style={{
          borderRadius: "14px"
        }}
      >

        <div className="card-body p-0">

          <div className="table-responsive">

            <table className="table table-bordered align-middle mb-0">

              <thead
                style={{
                  background: "#eef2ff"
                }}
              >
                <tr>

                  <th
                    style={{
                      width: "30%",
                      padding: "14px",
                      fontWeight: "700"
                    }}
                  >
                    Field
                  </th>

                  <th
                    style={{
                      padding: "14px",
                      fontWeight: "700"
                    }}
                  >
                    Value
                  </th>

                </tr>
              </thead>

              <tbody>

                <tr>
                  <td className="fw-bold">Repo ID</td>
                  <td>{renderValue(data.repo_id)}</td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Overall Vehicle Condition
                  </td>
                  <td>
                    {renderValue(data.overall_vehicle_condition)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Detailed Condition Notes
                  </td>
                  <td>
                    {renderValue(data.detailed_condition_notes)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Documentation Checklist
                  </td>
                 <td>

                    {

                      (() => {

                        try {

                          const docs = JSON.parse(
                            data.documentation_checklist || "[]"
                          );

                          if (
                            !Array.isArray(docs)
                          ) {

                            return "-";

                          }

                          return docs.join(", ");

                        } catch {

                          return "-";

                        }

                      })()

                    }

                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Supporting Documents
                  </td>
                  <td>

  {

    (() => {

      try {

        const docs = JSON.parse(
          data.supporting_documents || "{}"
        );

        if (
          !docs ||
          Object.keys(docs).length === 0
        ) {

          return "-";

        }

        const handleDownloadDocument = (
          filePath
        ) => {

          if (!filePath) {

            toast.error(
              "Document not available"
            );

            return;

          }

          const link =
            document.createElement("a");

          link.href =
            `${config.API_BASE_URL}${filePath}`;

          link.setAttribute(
            "download",
            filePath.split("/").pop()
          );

          document.body.appendChild(link);

          link.click();

          document.body.removeChild(link);

        };

        return Object.entries(docs).map(
          ([docName, filePath], index) => (

            <button
              key={index}
              className="
                btn
                btn-sm
                btn-info
                me-2
                mb-2
              "
              onClick={() =>
                handleDownloadDocument(
                  filePath
                )
              }
            >
              ⬇ Download {docName}
            </button>

          )
        );

      } catch {

        return "-";

      }

    })()

  }

</td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Place Of Repossession
                  </td>
                  <td>
                    {renderValue(data.place_of_repossession)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">RC Book</td>
                  <td>{renderValue(data.rc_book)}</td>
                </tr>

                <tr>
                  <td className="fw-bold">TC Book</td>
                  <td>{renderValue(data.tc_book)}</td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Insurance Certificate
                  </td>
                  <td>
                    {renderValue(data.insurance_certificate)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">Permit</td>
                  <td>{renderValue(data.permit)}</td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Fitness Report
                  </td>
                  <td>{renderValue(data.fitness_report)}</td>
                </tr>

                <tr>
                  <td className="fw-bold">Tarpaulin</td>
                  <td>{renderValue(data.tarpaulin)}</td>
                </tr>

                <tr>
                  <td className="fw-bold">Tool Kit</td>
                  <td>{renderValue(data.tool_kit)}</td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Radio Stereo
                  </td>
                  <td>{renderValue(data.radio_stereo)}</td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Rope / Rassi
                  </td>
                  <td>{renderValue(data.rope_rassi)}</td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Battery Make Number
                  </td>
                  <td>
                    {renderValue(data.battery_make_number)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">Electric</td>
                  <td>{renderValue(data.electric)}</td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Number Of Wheels
                  </td>
                  <td>
                    {renderValue(data.number_of_wheels)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Vehicle Condition
                  </td>
                  <td>
                    {renderValue(data.vehicle_condition)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Jack Available
                  </td>
                  <td>
                    {renderValue(data.jack_available)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Rod Available
                  </td>
                  <td>
                    {renderValue(data.rod_available)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Pana Available
                  </td>
                  <td>
                    {renderValue(data.pana_available)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Tyre Report
                  </td>
                  <td>{renderValue(data.tyre_report)}</td>
                </tr>

                <tr>
                  <td className="fw-bold">Battery No</td>
                  <td>{renderValue(data.battery_no)}</td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Controller No
                  </td>
                  <td>{renderValue(data.controller_no)}</td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Charger No
                  </td>
                  <td>{renderValue(data.charger_no)}</td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Front Left Side
                  </td>
                  <td>
                    {renderValue(data.front_left_side)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Front Left Tyre Make
                  </td>
                  <td>
                    {renderValue(data.front_left_tyre_make)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Front Right Side
                  </td>
                  <td>
                    {renderValue(data.front_right_side)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Front Right Tyre Make
                  </td>
                  <td>
                    {renderValue(data.front_right_tyre_make)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Rear Left Side
                  </td>
                  <td>
                    {renderValue(data.rear_left_side)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Rear Left Tyre Make
                  </td>
                  <td>
                    {renderValue(data.rear_left_tyre_make)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Rear Right Side
                  </td>
                  <td>
                    {renderValue(data.rear_right_side)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Rear Right Tyre Make
                  </td>
                  <td>
                    {renderValue(data.rear_right_tyre_make)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Right Side Mirror
                  </td>
                  <td>
                    {renderValue(data.right_side_mirror)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Rear Mirror
                  </td>
                  <td>
                    {renderValue(data.rear_mirror)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Left Side Mirror
                  </td>
                  <td>
                    {renderValue(data.left_side_mirror)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Spare Tyre
                  </td>
                  <td>
                    {renderValue(data.spare_tyre)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Spare Tyre Make
                  </td>
                  <td>
                    {renderValue(data.spare_tyre_make)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Additional Information
                  </td>
                  <td>
                    {renderValue(data.additional_information)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Checklist Status
                  </td>
                  <td>
                    {renderValue(data.checklist_status)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">Latitude</td>
                  <td>{renderValue(data.latitude)}</td>
                </tr>

                <tr>
                  <td className="fw-bold">Longitude</td>
                  <td>{renderValue(data.longitude)}</td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Location Address
                  </td>
                  <td>
                    {renderValue(data.location_address)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Attempt Count
                  </td>
                  <td>
                    {renderValue(data.attempt_count)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Created By
                  </td>

                  <td>
                    {renderValue(data.created_by_name)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Updated By
                  </td>

                  <td>
                    {renderValue(data.updated_by_name)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Created At
                  </td>

                  <td>
                    {renderValue(data.created_at)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Updated At
                  </td>

                  <td>
                    {renderValue(data.updated_at)}
                  </td>
                </tr>

              </tbody>

            </table>

          </div>

        </div>

      </div>

    </Container>

  );

}

export default ViewRepoChecklist;